import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
const ABTestBranchActionDetail = ({
  messageLangPath,
  numOfBranches,
  flowObjectTypeId
}) => {
  const options = {
    numOfBranches
  };
  return /*#__PURE__*/_jsx("div", {
    children: messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.ab-test-branch.action-detail.content_cob",
      options: options,
      objectTypeId: flowObjectTypeId
    }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.ab-test-branch.action-preview.content_cob",
      options: options,
      objectTypeId: flowObjectTypeId
    })
  });
};
export default ABTestBranchActionDetail;